
class EducorePerformanceAnalysis {
    constructor($scope, $state, $stateParams, $sce, $rootScope,
        authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS) {
        'ngInject';
        $rootScope.title = "Performance Analysis"
        let self = this
        let author = localStorageService.get('authoringData')
        $scope.showList = false
        $scope.isPdfData = false
        $scope.loading = true
        let myUserId = localStorageService.get('user_id')
        let activeAcd = localStorageService.get('academic_year')
        let school_id = localStorageService.get('school_id')
        let thisSchoolId = school_id
        let filterThru = localStorageService.get('can_filter')
        if (filterThru == "true") {
            filterThru = true
        } else {
            filterThru = undefined
        }
        var insideCourseware = false
        let LEVEL_ARRAY = [{
            level: "1",
            alias: "Easy"
        }, {
            level: "2",
            alias: "Medium"
        }, {
            level: "3",
            alias: "Difficult"
        }]
        //Boolean - To set view for fetch
        $scope.isFilter = true;

        //Object - Holds selection data
        $scope.selectAcademics = {};
        $scope.allAcademic_year = localStorageService.get('allAcademic_year')
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Performance Analysis"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getSession()
        }


        function getSession() {
            $scope.toSearchObj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: activeAcd,
                exam: {
                    $exists: 1
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.sessions = response.result.data.details;
                        $scope.selectAcademics.session = undefined;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.curriculums = [];
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                        $scope.loading = false;
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    $scope.loading = false
                    toastr.error('Network Error. Please try later')
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
        }

        $scope.getCuriculum = (session) => {
            $scope.selectAcademics.session = session;
            $scope.toSearchObj.session = $scope.selectAcademics.session._id;
            $scope.hasResult = false
             let searchObj = $scope.toSearchObj
             searchObj.academic_year=activeAcd
             authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", searchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.curriculums = response.result.data.details;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getClass = (curriculum) => {
            $scope.selectAcademics.curriculum = curriculum;
            $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classes = response.result.data.details;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getBatch = (xclass) => {
            $scope.selectAcademics.class = xclass;
            $scope.toSearchObj.class = $scope.selectAcademics.class._id;       
           
            $scope.loading = true
            setTimeout(() => {
            $scope.toSearchObj.academic_year_selected = $scope.toSearchObj.academic_year;
               if($scope.toSearchObj.academic_year && $scope.toSearchObj.academic_year.year){
                 let year=$scope.toSearchObj.academic_year.year
                 $scope.getReport(year)
               }              
               $scope.toSearchObj.academic_year  = $scope.toSearchObj.academic_year_selected 
               $scope.loading = false
            }, 100);

            
            // authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
            //     if (response.result && response.result.data && response.result.data.details) {
            //         try {
            //             $scope.batches = response.result.data.details;
            //             $scope.selectAcademics.batch = undefined;
            //             $scope.selectAcademics.subject = undefined;
            //             $scope.subjects = [];
            //         } catch (ex) {
            //             console.log(ex);
            //         }
            //     } else {
            //         toastr.error('Network Error. Please try later');
            //     }
            //     _.defer(function () {
            //         $scope.$apply();
            //     });
            // });
        }
        $scope.getReport = (year) => {   
             $scope.loading = false
            $scope.toSearchObj.academic_year = year
            loadStReport(thisSchoolId, $scope.toSearchObj)
        }
        $scope.getSubject = (batch) => {
            $scope.selectAcademics.batch = batch;
            $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.subjects = response.result.data.details;
                        $scope.selectAcademics.subject = undefined;
                       
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
        $scope.fetchReport = function (subject) {
            $scope.selectAcademics.subject = subject;
            $scope.selectedAcademics = angular.copy($scope.selectAcademics);
            $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
            loadStReport(thisSchoolId, $scope.toSearchObj)
        }
        $scope.barcodeToHtml = function () {
            let lines = $scope.REFERENCE.bcode.lines
            let barcodeNumber = $scope.REFERENCE.bcode.barcodeNumber
            return $sce.trustAsHtml(lines+barcodeNumber);
        }
        function loadStReport(thisSchoolId, academics) {
            self.noselection = false
            $scope.loading = true
            self.academicsForPdf = academics
            console.log(academics)
            let send = {
                "conditions": {
                    "class_id": academics.class,
                    "curriculum_id": academics.curriculum,
                    "batch_id": academics.batch ? academics.batch : undefined,
                    "subject_id": academics.subject ? academics.subject : undefined,
                    "session_id": academics.session,
                    "school_id": localStorageService.get('school_id')
                },
                "myUserId": myUserId,
                "acdYear": academics.academic_year ? academics.academic_year : activeAcd,
                // "student_id": "q72pkhd4GGKeoy7sA",
                "pdfFlag": false,
                "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
                "SITE_URL": CONSTANTS.SITE_URL
            }
            console.log(send)
            authService.callAPI("/v0/educore_reports/educorePerformanceAnalysis", "POST",
                { args: send }, function (resp) {
                    try {

                        if (!resp.error) {
                            let result = resp.result.data.details
                            console.log(result)
                            if (result.settSubject.length) {
                                self.hasResult = true
                            } else {
                                self.hasResult = false
                                $scope.showNoActivitiesFlag =true
                            }

                            console.log( self.hasResult)
                            $scope.REFERENCE = result.REFERENCE
                            self.settSubject = result.settSubject
                            self.settBatch = result.settBatch
                            self.average_per_term = result.ret_val.average_per_term
                            self.reportCardConsoleDetails = result.reportCardConsoleDetails
                            self.section_performance = result.ret_val.section_performance
                            self.needing_attention = result.ret_val.needing_attention
                            self.less_than_sixty = result.less_than_sixty
                            self.average_per_term_color = result.ret_val.average_per_term_color
                            self.header = result.header
                            self.generator = result.generator
                            $scope.urls = result.pdf_url
                            // console.log(self.average_per_term)
                            // console.log(self.average_per_term_color)
                            $scope.loading = false
                            $scope.$apply()
                        } else {
                            $scope.loading = false;
                            toastr.error("Network error");
                        }
                        $scope.loading = false;
                        $scope.$apply()
                    } catch (e) {
                        $scope.loading = false;
                        $scope.$apply()
                        console.log(e)
                    }

                    $scope.loading = false
                    $scope.$apply()
                })
            //   Meteor.call('educorePerformanceAnalysis', thisSchoolId, academics, false, function(err, result){
            //       if(result){
            //           console.log(result)
            //           // if(result.settSubject.length){
            //           //     self.noData = false
            //           // }
            //           if(result.settSubject.length){
            //               self.hasResult = true
            //           }else{
            //               self.hasResult = false
            //           }
            //           self.settSubject = result.settSubject
            //           self.settBatch = result.settBatch
            //           self.average_per_term = result.ret_val.average_per_term
            //           self.reportCardConsoleDetails = result.reportCardConsoleDetails
            //           self.section_performance = result.ret_val.section_performance
            //           self.needing_attention = result.ret_val.needing_attention
            //           self.less_than_sixty = result.less_than_sixty
            //           self.average_per_term_color = result.ret_val.average_per_term_color
            //           self.header = result.header
            //           self.generator = result.generator
            //           // console.log(self.average_per_term)
            //           // console.log(self.average_per_term_color)
            //           $scope.loading = false
            //           $scope.$apply()
            //       }
            //   })
        }

        // self.noData = true
        // self.acd = author.session +"/"+ author.curriculum+"/"+author.class+"/"+author.batch


        self.goToThisTermAtention = (report_console, subject) => {
            console.log(self.settSubject)
            self.subjectSelected = subject.name
            self.selectedReport = report_console.report_name
            Meteor.call('getMarksPerRcLessThanSixty', author.school_id, Session.get('authoringData'), subject._id, self.settSubject, function (err, res) {
                console.log(res)
                self.studentData = res.studentData
                self.reportCardConsoleDetails = res.reportCardConsoleDetails
                $scope.showList = true
                $scope.$apply()
            })
        }
        self.backToHtml = () => {
            $scope.isPdfData = false
        }
        self.export = () => {
            // $scope.loading = true
            $scope.isPdfData = true
            $scope.url = $sce.trustAsResourceUrl($scope.urls)
        }

        self.showHideSubjectr = (subject) => {
            _.each(self.settSubject, function (oneSubject) {
                if (oneSubject._id == subject._id) {
                    if (subject.is_active) {
                        oneSubject.is_active = false
                    } else {
                        oneSubject.is_active = true
                    }
                } else {
                    oneSubject.is_active = false
                }
            })
        }
    }
}
export default EducorePerformanceAnalysis;


// WEBPACK FOOTER //
// ./src/app/educore_reports/performance_analysis/controllers/controller.js